import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { StoryContentTrackingService } from '../story-content-tracking.service';
import { ContentSubStory } from '../story-content.model';

@Component({
    selector: 'ms-story-details',
    templateUrl: './story-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgScrollbarModule, NgOptimizedImage, TrustPipe],
})
export class StoryDetailsComponent {
    @Input() title: string;
    @Input() subStory: ContentSubStory;

    @HostBinding('class.story-content-details') class = true;

    constructor(
        private activeModal: ActiveModal,
        private storyContentTrackingService: StoryContentTrackingService,
    ) {}

    closePopup(): void {
        this.activeModal.close();
        this.storyContentTrackingService.trackPopupClose(true, this.title);
    }
}
